import { createFeature } from '@edreamsodigeo/frontend-core';
import { ITINERARY_DEAL_MOBILE, PRIME_DAYS } from 'clientState/ab/aliases';
import AirlineCampaignDecorationRevamp from '@components/Results/Components/ThreeColumnsItinerary/Campaigns/AirlineCampaign/AirlineCampaignDecoration';
import ItineraryDecorationRevamp from '@components/Results/Components/ThreeColumnsItinerary/ItineraryDecoration/index';
import ItineraryPrimeDaysDecoration from '@components/Results/Components/ThreeColumnsItinerary/ItineraryDecoration/ItineraryPrimeDaysDecoration';

export const ItineraryDecorationMobile = createFeature({
  name: PRIME_DAYS,
  variations: [
    AirlineCampaignDecorationRevamp,
    ItineraryPrimeDaysDecoration,
    ItineraryPrimeDaysDecoration,
  ],
  version: 1,
});

export const ItineraryDealDecoration = createFeature({
  name: ITINERARY_DEAL_MOBILE,
  variations: [
    ItineraryDecorationMobile,
    ItineraryDecorationRevamp,
    ItineraryDecorationRevamp,
  ],
  version: 1,
});

export default ItineraryDealDecoration;
